<template>
  <div
    class="checkboxes-wrapper"
    :class="{ error: showFormError, required: required }"
  >
    <p class="checkboxes__title">{{ label }}</p>
    <p
      class="field-description"
      v-if="fieldData.description"
      v-html="fieldData.description"
    />
    <p class="forms__help-text" v-if="helpText.length > 0">{{ helpText }}</p>
    <label class="checkbox-container" v-for="option in fieldData.options">
      <input
        type="checkbox"
        :id="option.id"
        :name="fieldData.name"
        :value="option.value"
        @input="onInput"
      />
      <span class="checkmark"></span>
      <span class="checkbox__title">{{ option.label }}</span>
    </label>
    <p
      class="forms__error-message"
      v-if="showFormError"
      v-t="'errors.required_field'"
      role="alert"
    />
    <div class="input-wrapper" v-if="fieldData.other">
      <input
        class="input"
        type="text"
        :placeholder="other.label"
        :id="other.id"
        :required="other.required"
        v-model="otherValue"
      />
      <label class="floating-label" :for="other.id">{{ other.label }}</label>
    </div>
  </div>
</template>
<script>
import AbstractField from "@/util/AbstractField";
import _ from 'lodash';

export default {
  name: "checkboxes",
  mixins: [AbstractField],
  data() {
    return {
      selectedOptions: {},
      otherValue: "",
    };
  },
  watch: {
    submittedValue: function(val) {
      this.value = val;
    }
  },
  methods: {
    onInput(event) {
      this.$set(this.selectedOptions, event.target.value, event.target.checked);
    },
  },
  computed: {
    submittedValue() {
      let checked = _.keys(_.pickBy(this.selectedOptions, _.isTrue));

      if (this.otherValue.length > 0) {
        checked.push(this.otherValue);
      }

      return checked.join(';');
    }
  }
};
</script>